/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';
import { StatsModuleConfigProps } from 'components/StatsModule/config';

const StatsModule: FC<StatsModuleConfigProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);
  const { stats = [] } = rest;

  return (
    <Section {...sectionProps}>
      {/* Desktop */}
      <div className="hidden lg:block">
        <div className="relative mx-auto w-full max-w-[930px]">
          <div className="border border-primary-800">
            <div className="grid grid-cols-3 divide-x divide-primary-1200">
              {stats.map((stat, index) => (
                <div key={index} className="flex h-40 flex-col items-center justify-center px-6">
                  <ScrollFadeSection delay={0.1 * (index + 1)}>
                    <div className="text-center font-spaceGrotesk text-6xl leading-[72px] text-primary-300">
                      {stat.value}
                    </div>
                    <div className="text-center text-lg leading-7 text-white">{stat.description}</div>
                  </ScrollFadeSection>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="mx-auto flex max-w-sm flex-col border border-primary-800 lg:hidden">
        {stats.map((stat, index) => (
          <div key={index} className="relative">
            <div className="flex flex-col items-center justify-center px-6 py-10">
              <ScrollFadeSection delay={0.1 * (index + 1)}>
                <div className="text-center font-spaceGrotesk text-6xl leading-[72px] text-primary-300">
                  {stat.value}
                </div>
                <div className="text-center text-lg leading-7 text-white">{stat.description}</div>
              </ScrollFadeSection>
            </div>
            {index < stats.length - 1 && <div className="h-px w-full bg-primary-800" />}
          </div>
        ))}
      </div>
    </Section>
  );
};

export default StatsModule;
